/**
 * DOCS SEARCH
 * 
 * moteur de recherche de documents dans
 * la partie PRO de l'espace mon compte
 */
import $ from "jquery";
import { debounce } from 'throttle-debounce';
import Mark from 'mark.js';
const utils = require('../utils.js').default;

const DOCSSearch = (() => {
    const DOM_DOCS_LIST = '.js-documents-list';
    const DOM_DOCS_SEARCH = '#js-search-document';

    /**
     * DOCS SEARCH RESET (func)
     * 
     * réinitialisation de la recherche
     */
    const docsSearchReset = () => {
        $(`${DOM_DOCS_LIST} .js-docs-group`)
        .slideDown()
        .find('tr').removeClass('c-table__row--animation--hidden');
    };
    /**
     * DOCS SEARCH (func)
     * 
     * gestion du module de recherche via 
     * un input[text] de recherche
     */
    const docsSearch = () => {
        var instanceMark = new Mark(DOM_DOCS_LIST);
        $(DOM_DOCS_SEARCH).on('keyup', debounce(500, (event) => {
            let search = $(event.currentTarget).val();
            if (search.length > 2){
                instanceMark.unmark({
                    done: function() {
                        instanceMark.mark(search, {separateWordSearch:false});
                        $(`${DOM_DOCS_LIST} .js-docs-group`).each(function() {
                            if ($(this).find('h2 mark').length === 0){
                                if ($(this).find('.js-docs-list mark').length === 0) {
                                    $(this).slideUp();
                                } else {
                                    $(this).find('.js-docs-list tr').each(function () {
                                        if ($(this).find('mark').length === 0) {
                                            $(this).addClass('c-table__row--animation--hidden');
                                        } else {
                                            $(this).removeClass('c-table__row--animation--hidden');
                                        }
                                    })
                                }
                            } else {
                                $(this).slideDown().find('tr').removeClass('c-table__row--animation--hidden');
                            }
                        })
                    }
                });
            } else {
                instanceMark.unmark();
                docsSearchReset();
            }
        }))
    };
    /**
     * INIT (func)
     */
    const init = () => {
        utils.debug('DOCS SEARCH', 'initialisation');   
        docsSearch();
    };
    return {init}
})();
export default DOCSSearch;